import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import CreateAdCampaignView from './CreateAdCampaignView';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CreateAdCampaignView />
    </div>
  );
};
